// Libs
import React, { Component } from 'react'
import { Row, Col } from '../../../../components/Elemental'

// CSS
import './styles.scss'

class SearchListHeader extends Component {
  render() {
    return (
      <div className="search-list-header">
        <Row className="search-list-header__row">
          <Col xs="10%">
            <p>Caso</p>
          </Col>
          <Col xs="17%">
            <p>Processo</p>
          </Col>
          <Col xs="13%">
            <p>Código Sistema</p>
          </Col>
          <Col xs="15%">
            <p>Autor</p>
          </Col>
          <Col xs="15%">
            <p>Advogado</p>
          </Col>
          <Col xs="15%">
            <p>Empresa</p>
          </Col>
          <Col xs="15%">
            <p>Escritório</p>
          </Col>
        </Row>
      </div>
    )
  }
}

export default SearchListHeader
